import React from 'react'
import './Gutargun.css';
import logoGutargun from '../img/GUTARGU.png'
import maga1 from '../img/p1.png'

export default function Gutargun() {
    return (
        <>
            <div className="Gutargun">
                {/* <div className="headGutargun">
            <img src={logoGutargun} alt="" />
        </div> */}
                <h1>GUTARGU</h1>
                <p>Sub Project of Initiative Astitva</p>

                <div className="magazinSection">
                    <h1>EXCLUSIVE MAGAZINES</h1>
                    <div className="boxMagazin">
                        <div className="imgBoxMagazin">
                            <img src={maga1} alt="" />
                        </div>
                        <div className="discriptionMagazin">
                            <h3>22 August </h3>
                            <h1>The Silent Pendimic</h1>
                            <p>An oxymoron which became our reality and changed the world in an unprecedented way. What once were loud and roaring streets, now became deadly silent. Lockdown has been – and continues to be – a very challenging period for many of us, but it has also forced us to prioritize our mental and physical health.Shedding light on how India as a country, crossed all the hurdles laid in its path, we, Enactus ADGITM, present to you, the fourth edition of Gutargu: THE SILENT PANDEMONIUM</p>
                            <h4>Read More</h4>
                        </div>
                    </div>
            
                    <div className="boxMagazin">
                        <div className="imgBoxMagazin">
                            <img src={maga1} alt="" />
                        </div>
                        <div className="discriptionMagazin">
                            <h3>22 August </h3>
                            <h1>The Silent Pendimic</h1>
                            <p>An oxymoron which became our reality and changed the world in an unprecedented way. What once were loud and roaring streets, now became deadly silent. Lockdown has been – and continues to be – a very challenging period for many of us, but it has also forced us to prioritize our mental and physical health.Shedding light on how India as a country, crossed all the hurdles laid in its path, we, Enactus ADGITM, present to you, the fourth edition of Gutargu: THE SILENT PANDEMONIUM</p>
                            <h4>Read More</h4>
                        </div>
                    </div>
            
                    <div className="boxMagazin">
                        <div className="imgBoxMagazin">
                            <img src={maga1} alt="" />
                        </div>
                        <div className="discriptionMagazin">
                            <h3>22 August </h3>
                            <h1>The Silent Pendimic</h1>
                            <p>An oxymoron which became our reality and changed the world in an unprecedented way. What once were loud and roaring streets, now became deadly silent. Lockdown has been – and continues to be – a very challenging period for many of us, but it has also forced us to prioritize our mental and physical health.Shedding light on how India as a country, crossed all the hurdles laid in its path, we, Enactus ADGITM, present to you, the fourth edition of Gutargu: THE SILENT PANDEMONIUM</p>
                            <h4>Read More</h4>
                        </div>
                    </div>
            
                    <div className="boxMagazin">
                        <div className="imgBoxMagazin">
                            <img src={maga1} alt="" />
                        </div>
                        <div className="discriptionMagazin">
                            <h3>22 August </h3>
                            <h1>The Silent Pendimic</h1>
                            <p>An oxymoron which became our reality and changed the world in an unprecedented way. What once were loud and roaring streets, now became deadly silent. Lockdown has been – and continues to be – a very challenging period for many of us, but it has also forced us to prioritize our mental and physical health.Shedding light on how India as a country, crossed all the hurdles laid in its path, we, Enactus ADGITM, present to you, the fourth edition of Gutargu: THE SILENT PANDEMONIUM</p>
                            <h4>Read More</h4>
                        </div>
                    </div>
            
            
                </div>
            </div>
        </>
    )
}
